import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';

// iOS doesn't recognize 'monospace' - need specific font name
const monoFont = Platform.select({
    ios: 'Courier',
    android: 'monospace',
    default: 'monospace',
});

/**
 * DigitalDisplay - 7-segment style display for power metrics
 * Shows Power (W), Amps (A), Voltage (V) in a digital clock-like font
 */
function DigitalDisplay({
    power = 0,
    amps = 0,
    voltage = 0,
}) {
    // Format power to show as whole number with smaller decimal
    const powerWhole = Math.floor(power);
    const powerDecimal = Math.round((power - powerWhole) * 100);

    return (
        <View style={styles.container}>
            {/* Main power display */}
            <View style={styles.mainDisplay}>
                <Text style={styles.powerValue}>{powerWhole}</Text>
                <View style={styles.subValues}>
                    <Text style={styles.ampsValue}>{amps.toFixed(2)}A</Text>
                    <Text style={styles.voltageValue}>{voltage}V</Text>
                </View>
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        paddingVertical: 20,
    },
    mainDisplay: {
        flexDirection: 'row',
        alignItems: 'flex-end',
    },
    powerValue: {
        fontSize: 72,
        fontWeight: 'bold',
        color: '#1a1a2e',
        fontFamily: monoFont,
        letterSpacing: -2,
    },
    subValues: {
        marginLeft: 8,
        marginBottom: 12,
    },
    ampsValue: {
        fontSize: 18,
        color: '#1a1a2e',
        fontFamily: monoFont,
    },
    voltageValue: {
        fontSize: 18,
        color: '#1a1a2e',
        fontFamily: monoFont,
    },
});

export default DigitalDisplay;
